<div
  class="grid gap-4"
  [class.grid-cols-4]="columns() === 4"
  [class.grid-cols-5]="columns() === 5"
  [class.grid-cols-6]="columns() === 6"
>
  @if (kpis().totalInstallations !== null) {
    <a
      class="block"
      data-testid="kpi-total-installations"
      [routerLink]="['/', APP_PATHS.Installations]"
    >
      <xemex-stat-card
        [label]="'home.kpi.totalInstallations' | translate"
        [value]="kpis().totalInstallations ?? 0"
        size="lg"
      ></xemex-stat-card>
    </a>
  }
  @if (kpis().incompleteInstallations !== null) {
    <a
      class="block"
      data-testid="kpi-incomplete-installations"
      [routerLink]="['/', APP_PATHS.Installations]"
      [queryParams]="{ commissioning: 'incomplete' }"
    >
      <xemex-stat-card
        [label]="'home.kpi.incompleteCommissioning' | translate"
        [value]="kpis().incompleteInstallations ?? 0"
        size="lg"
      ></xemex-stat-card>
    </a>
  }
  <xemex-stat-card
    [label]="'home.kpi.totalLocations' | translate"
    [value]="kpis().totalLocations"
    size="lg"
  ></xemex-stat-card>
  <xemex-stat-card
    [label]="'home.kpi.totalDevices' | translate"
    [value]="kpis().totalDevices"
    size="lg"
  ></xemex-stat-card>
  <xemex-stat-card
    [label]="'home.kpi.openAlarms' | translate"
    [value]="kpis().openAlarms"
    size="lg"
  ></xemex-stat-card>
  <xemex-stat-card
    [label]="'home.kpi.alarmsLast7Days' | translate"
    [value]="kpis().alarmsLast7Days"
    size="lg"
  ></xemex-stat-card>
</div>
